import { Layout } from "antd";
import { useEffect, useState } from "react";
import {
  fetchApiRelease,
  newestRelease,
  webRelease,
} from "../../../shared/release";

// The year Air1 Insurance was first released; the range runs to the year of the latest release
const FIRST_RELEASE_YEAR = 2024;

const LayoutFooter = () => {
  const [apiRelease, setApiRelease] = useState(null);

  useEffect(() => {
    let active = true;
    fetchApiRelease().then((release) => {
      if (active) setApiRelease(release);
    });
    return () => {
      active = false;
    };
  }, []);

  const { version, date } = newestRelease(webRelease(), apiRelease);
  const latestYear = date ? Number(date.slice(0, 4)) : new Date().getFullYear();
  const years =
    latestYear > FIRST_RELEASE_YEAR
      ? `${FIRST_RELEASE_YEAR}–${latestYear}`
      : `${FIRST_RELEASE_YEAR}`;
  const release = [version, date].filter(Boolean).join(" ") || "development";

  return (
    <Layout.Footer style={{ textAlign: "center" }}>
      {`Air1 Insurance ©${years} Created by Fideli Software Solutions Inc. (${release})`}
    </Layout.Footer>
  );
};

export default LayoutFooter;
